

<template>
<div>
<!-- <v-container> -->
<v-row>
<v-col cols="12" sm="12" lg="12">
   <PrincipalRegister></PrincipalRegister>
</v-col>
</v-row>   


 <v-row justify="end" >
        
        <v-col cols="2" >





        </v-col>
      </v-row>

      
<!-- </v-container> -->
   
</div>
</template>

<script>

import PrincipalRegister from '@/components/auto_register/PrincipalRegister.vue';




export default {
    data () {
    return {
              
    }
  },
  components: {
    
    PrincipalRegister
    
  },

  methods: {

}

}
    

</script>


